import Header from '../../../components/header'
import Footer from '../../../components/footer'
import { useState } from "react";
import axios from "axios";
import style from './04_accountdeletion.css'
import img from '../../Images/Hero.png'

import step1 from '../../Images/account.png'
import step2 from '../../Images/search-person.png'
import step3 from '../../Images/phone-call.png'

import trust1 from '../../Images/honorable.png'
import trust2 from '../../Images/nearby.png'
import trust3 from '../../Images/10815875.png'
import trust4 from '../../Images/language.png'
import trust5 from '../../Images/phone-call_02.png'
import trust6 from '../../Images/free_02.png'
import PricingTeachers from '../../components/03_pricingteachers/03_pricingteachers';

export default function AccountDeletion() {
    const [form, setForm] = useState({
        fullname: "",
        email: "",
        phone: "",
    });

    const handleChange = (e) => {
    const { name, value, multiple, options, files } = e.target;

    if (files) {
        setForm(prev => ({
            ...prev,
            [name]: files[0]
        }));
        return;
    }

    if (multiple) {
        const values = Array.from(options)
            .filter(option => option.selected)
            .map(option => option.value);

        setForm(prev => ({
            ...prev,
            [name]: values,
        }));
    } else {
        setForm(prev => ({
            ...prev,
            [name]: value,
        }));
    }
};

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();

    Object.entries(form).forEach(([key, value]) => {

        if (value === null) return;

        if (Array.isArray(value)) {
            value.forEach(item => {
                formData.append(`${key}[]`, item);
            });
        } else {
            formData.append(key, value);
        }

    });

      const res = await axios.post(
        "https://sursaathi.in/accdel.php",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      alert(res.data.message || "Registration Successful");
      setForm({
        fullname: "",
        email: "",
        phone: "",
      });
    } catch (err) {
      alert(
        err.response?.data?.error ||
          err.response?.data?.message ||
          "Something went wrong"
      );
    }
  };
    return (
        <div style={{ backgroundColor: '#FFFDF4' }}>
            <Header />
                <div className='AccountDelectionPage-Main'>
                    <div className='AccountDelectionPage-Main-Info'>
                        <h2>Delete Your SurSaathi Listing</h2>
                        <p>No longer want your teacher profile on SurSaathi? You can request to have your listing deleted. The process is simple and takes up to 1 week after verification.</p>
                        <h3>How It Works</h3>
                        <div className='AccountDelectionPage-Main-Info-Step'>
                            <span>1. Fill Out the Deletion Form</span>
                            <p>Submit the account deletion form with the details associated with your SurSaathi teacher profile.</p>
                        </div>
                        <div>
                            <span>2. We will Verify Your Request</span>
                            <p>A member of the SurSaathi team will contact you to verify your identity and confirm that you want to delete your listing.</p>
                        </div>
                        <div>
                            <span>3. Your Listing Is Deleted</span>
                            <p>Once your request has been verified, your listing will be removed from SurSaathi within 1 week.</p>
                        </div>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <h2>Ready to Delete Your Listing?</h2>
                        <p>Fill out the form below to start the account deletion process.</p>
                        <label>Full Name</label>
                        <input
                        type="text"
                        name="fullname"
                        value={form.fullname}
                        onChange={handleChange}
                        required
                        />

                        <label>Phone No</label>
                        <input
                        type="tel"
                        name="phone"
                        value={form.phone}
                        onChange={handleChange}
                        required
                        />

                        <label>Email</label>
                        <input
                        type="email"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        required
                        />
                        <button type="submit">Submit</button>
                    </form>
                </div>
            <Footer />
        </div>
    );
}
